<template>
  <div>
    Selecting this option displays an estimation of a chaser reaction maneuver.

    <br />
    <br />

    A new section is added to the comparator :
    <b> Chaser reaction maneuver details </b>. It displays the updated metrics
    of the scenario taking into consideration a possible chaser reaction
    maneuver meant to create a new cojunction in the coming day after the
    evasive maneuver.

    <br />
    <br />

    In addition to those details, the "evasive + chaser reaction" scenario is
    added to every graphs in the comparator scenario card.
  </div>
</template>

<script>
export default {
  name: 'tooltipChaserReactionDisplayOption'
}
</script>
